import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function YearlyReport({isHideSideMenu}) {
    const [year, setYear] = useState("");
    const [classificationId, setClassificationId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [locationId, setLocationId] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/year/${year}/paytype/${payTypeId}/classification/${classificationId}/location/${locationId}/summary`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [classificationId, locationId, payTypeId, year]);

    const generate = async () =>{
        setLoading(false);

        if(!year
            || !classificationId
            || !payTypeId
        ){
            setLoading(false);
            setErrorState(true);
            return;
        }
        setErrorState(false);
        
        const logs = await fetchData();
        
        if(logs.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            setLoading(false);
            return;
        }

        console.log(logs)
        generateDownloadReport(logs)
    };

    /* const generateDownloadReport = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet(`DATA`);

        const header = [
            'User Id',
            'Employee Name',
            'Section',
            '',
            'Jan.',
            'Feb.',
            'March',
            'April',
            'May',
            'June',
            'July',
            'Aug.',
            'Sept.',
            'Oct.',
            'Nov.',
            'Dec.',
            '',
            'Total',
            'Total MOS',
            'Round Up',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'sectionDescription', width: 30 },
            { key: '', width: 10},
            { key: 'januaryTotalDays', width: 10 },
            { key: 'februaryTotalDays', width: 10 },
            { key: 'marchTotalDays', width: 10 },
            { key: 'aprilTotalDays', width: 10 },
            { key: 'mayTotalDays', width: 10 },
            { key: 'juneTotalDays', width: 10 },
            { key: 'julyTotalDays', width: 10 },
            { key: 'augustTotalDays', width: 10 },
            { key: 'septemberTotalDays', width: 10 },
            { key: 'octoberTotalDays', width: 10 },
            { key: 'novemberTotalDays', width: 10 },
            { key: 'decemberTotalDays', width: 10 },
            { key: '', width: 10 },
            { key: 'totalDaysOverAll', width: 10 },
            { key: 'totalMos', width: 10 },
            { key: 'roundUp', width: 10 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: false };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'EAEAEA' },
            };
        });

        worksheet1.getRow(1).height = 40;

        data.forEach(info => {
            worksheet1.addRow([
                info.employeePersonalInformationEmployeeId,
                info.employeePersonalInformationFullName,
                info.sectionDescription,
                "",
                info.januaryTotalDays,
                info.februaryTotalDays,
                info.marchTotalDays,
                info.aprilTotalDays,
                info.mayTotalDays,
                info.juneTotalDays,
                info.julyTotalDays,
                info.augustTotalDays,
                info.septemberTotalDays,
                info.octoberTotalDays,
                info.novemberTotalDays,
                info.decemberTotalDays,
                "",
                info.totalDaysOverAll,
                info.totalMos,
                info.roundUp,
            ]);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'YEARLY_REPORT.xlsx');
    }, []); */

    const generateDownloadReport = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();

        // 1. Helper function to create a sheet with a specific dataset
        const createSheet = (sheetName, dataset) => {
            // Excel tab name cleanup: no special chars, max 31 chars
            const safeName = sheetName.replace(/[\\/?*[\]]/g, "").substring(0, 31);
            const ws = workbook.addWorksheet(safeName);

            const header = [
                'User Id', 'Employee Name', 'Position', '', 
                'Jan.', 'Feb.', 'March', 'April', 'May', 'June', 
                'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.', 
                '', 'Total', 'Total MOS', 'Round Up'
            ];

            const headerRow = ws.addRow(header);
            ws.columns = [
                { key: 'employeePersonalInformationEmployeeId', width: 20 },
                { key: 'employeePersonalInformationFullName', width: 30 },
                { key: 'positionDescription', width: 25 },
                { key: 'spacer1', width: 5 },
                { key: 'jan1', width: 8 }, { key: 'feb1', width: 8 }, { key: 'mar1', width: 8 },
                { key: 'apr1', width: 8 }, { key: 'may1', width: 8 }, { key: 'jun1', width: 8 },
                { key: 'jul1', width: 8 }, { key: 'aug1', width: 8 }, { key: 'sep1', width: 8 },
                { key: 'oct1', width: 8 }, { key: 'nov1', width: 8 }, { key: 'dec1', width: 8 },
                { key: 'spacer2', width: 5 },
                { key: 'totalDaysOverAll', width: 10 },
                { key: 'totalMos', width: 10 },
                { key: 'roundUp', width: 10 },
            ];

            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
            });

            ws.getRow(1).height = 35;

            dataset.forEach(info => {
                ws.addRow([
                    info.employeePersonalInformationEmployeeId,
                    info.employeePersonalInformationFullName,
                    info.positionDescription,
                    "",
                    info.januaryTotalDays,
                    info.februaryTotalDays,
                    info.marchTotalDays,
                    info.aprilTotalDays,
                    info.mayTotalDays,
                    info.juneTotalDays,
                    info.julyTotalDays,
                    info.augustTotalDays,
                    info.septemberTotalDays,
                    info.octoberTotalDays,
                    info.novemberTotalDays,
                    info.decemberTotalDays,
                    "",
                    info.totalDaysOverAll,
                    info.totalMos,
                    info.roundUp,
                ]);
            });
        };

        // 2. Separate data into "Specific Locations" and "No Location"
        const validLocationData = data.filter(item => item.locationDescription && item.locationDescription.trim() !== "");
        const noLocationData = data.filter(item => !item.locationDescription || item.locationDescription.trim() === "");

        // 3. Group the valid location data by Location name
        const groupedByLocation = validLocationData.reduce((acc, item) => {
            const loc = item.locationDescription;
            if (!acc[loc]) acc[loc] = [];
            acc[loc].push(item);
            return acc;
        }, {});

        // --- SHEET CREATION ORDER ---

        // TAB 1: OVERALL (All data)
        createSheet("OVERALL", data);

        // TAB(S) 2+: Individual Locations (Sorted alphabetically)
        const sortedLocations = Object.keys(groupedByLocation).sort();
        sortedLocations.forEach(locName => {
            createSheet(locName, groupedByLocation[locName]);
        });

        // LAST TAB: NO LOCATION (Only if there are records without a location)
        if (noLocationData.length > 0) {
            createSheet("NO LOCATION", noLocationData);
        }

        // 4. Finalize file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `YEARLY_REPORT_${year}.xlsx`);
    }, [year]);

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Yearly Report"}</span>
                            </div>
                            <h3>Generate Yearly Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Year</div>
                                    <div className="info-item-input">
                                        <Year year={year} setYear={setYear}/>
                                    </div>
                                    <span style={{
                                                visibility: !year && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                                    </div>
                                    <span style={{
                                                visibility: !classificationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Pay Type</div>
                                    <div className="info-item-input">
                                        <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                                    </div>
                                    <span style={{
                                                visibility: !payTypeId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: !locationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const handleSelectChange = (event) => {
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value={0} >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function PayTypeIdSelect({payTypeId, setPayTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayTypeId(event.target.value);
    };
    
    const [payTypeIds, setPayTypeIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setPayTypeIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payTypeId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose pay type</option>
            {payTypeIds.map((payTypeId) => ( 
                SetPayTypeIds(payTypeId)
            ))}
            </select>
        </div>
    );
};
function SetPayTypeIds(payTypeId){
    return(
        <option id={"holidayType" + payTypeId.id} value={payTypeId.id}>{payTypeId.description}</option>
    )
    
}
function Year({year, setYear}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setYear(event.target.value);
        setIsSelected(true);
    };

    // Generate years from 2019 to the current year
    const getCurrentYear = () => new Date().getFullYear();
    const startYear = 2019;
    const years = Array.from({ length: getCurrentYear() - startYear + 1 }, (_, index) => (startYear + index).toString());

    useEffect(() => {
        if(year !== "" && year !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [year]);

    return (
        <div>
            <select id="yearSSSReport-select" value={year} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose a year</option>
            {years.map((yearName, index) => (
                <option key={index} value={yearName}>{yearName}</option>
            ))}
            </select>
        </div>
    );
};

export default YearlyReport
